import httpClient from "@/API/HttpClient";

// Language
const getActiveLanguages = () => httpClient.get(`language/active`);

// Login
const login = (phone, password) => httpClient.post(`login`, {phone, password});
const postFCMToken = (fcm_token) => httpClient.post(`fcm_token`, {fcm_token});

// Profile
const getProfile = () => httpClient.get(`profile`);


// Orders
const getOrders = (type, page, room_number, status) => httpClient.get(`orders`, {
    params: {
        type,
        room_number,
        status,
        page,
    }
}); // Type = [restaurant, shop, caffe]
const updateOrder = (id, status, deny_reason) => httpClient.post(`orders/${id}`, {status, deny_reason, _method: 'put'});
const getServiceRequests = (room_number, status) => httpClient.get(`service-requests?room_number=${room_number || ''}&status=${status || ''}`);
const updateServiceRequests = (id, status) => httpClient.post(`service-requests/${id}`, {status, _method: 'put'});


/*
* -----------------------------------
* | Management
* -----------------------------------
 */

// Category
const getCategories = (type) => httpClient.get(`category?type=${type}`); // Type = [service, restaurant, shop, caffe]
const createCategory = (category) => httpClient.post(`category`, category);
const updateCategory = (id, category) => httpClient.post(`category/${id}`, category);
const getCategoryProducts = (id) => httpClient.get(`category/${id}`);

// Product
const createProduct = (product) => httpClient.post(`product`, product);
const updateProduct = (id, product) => httpClient.post(`product/${id}`, product);

/*
* -----------------------------------
* | Admin
* -----------------------------------
 */

// Room
const getRooms = () => httpClient.get(`room`);
const createRoom = (room) => httpClient.post(`room`, room);
const updateRoom = (id, room) => httpClient.post(`room/${id}`, room);

// Role
const getRoles = () => httpClient.get(`role`);
const createRole = (role) => httpClient.post(`role`, role);
const updateRole = (id, role) => httpClient.post(`role/${id}`, role);

// User
const getUsers = () => httpClient.get(`user`);
const createUser = (user) => httpClient.post(`user`, user);
const updateUser = (id, user) => httpClient.post(`user/${id}`, user);

// Service
const createService = (service) => httpClient.post(`service`, service);
const updateService = (id, service) => httpClient.post(`service/${id}`, service);
const getDepartment = () => httpClient.get(`department`);

// Slider
const getSliders = () => httpClient.get(`slider`);
const createSlider = (slider) => httpClient.post(`slider`, slider);
const updateSlider = (id, slider) => httpClient.post(`slider/${id}`, slider);
const deleteSlider = (id) => httpClient.delete(`slider/${id}`);

// SurveyQuestion
const getSurveyQuestions = () => httpClient.get(`survey-question`);
const createSurveyQuestion = (question) => httpClient.post(`survey-question`, question);
const updateSurveyQuestion = (id, question) => httpClient.post(`survey-question/${id}`, question);
const deleteSurveyQuestion = (id) => httpClient.delete(`survey-question/${id}`);

// Language
const getLanguages = () => httpClient.get(`language`);
const createLanguage = (language) => httpClient.post(`language`, language);
const updateLanguage = (id, language) => httpClient.post(`language/${id}`, language);

// Survey
const getSurveys = () => httpClient.get(`survey`);

export {
    getActiveLanguages,
    login,
    postFCMToken,
    getProfile,
    getCategories,
    createCategory,
    updateCategory,
    getCategoryProducts,
    createProduct,
    updateProduct,
    getOrders,
    updateOrder,
    getServiceRequests,
    updateServiceRequests,
    getRooms,
    createRoom,
    updateRoom,
    getRoles,
    createRole,
    updateRole,
    getUsers,
    createUser,
    updateUser,
    getDepartment,
    createService,
    updateService,
    getSliders,
    createSlider,
    updateSlider,
    deleteSlider,
    getSurveyQuestions,
    createSurveyQuestion,
    updateSurveyQuestion,
    deleteSurveyQuestion,
    getSurveys,
    getLanguages,
    createLanguage,
    updateLanguage,
}
